import React from 'react'
import './Footer.scss'

export default function Footer() {
  return (
    <div className="container footer">
      <p>&copy; abz.agency special for the test task</p>
    </div>
  )
}
